var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6703",
    "data-name": "Group 6703",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.44,
    height: 15.44,
    viewBox: "0 0 15.44 15.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M0,0H15.44V15.44H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-bar-left",
    transform: "translate(1.994 1.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4591",
    "data-name": "Path 4591",
    d: "M8.368,10.271a.5.5,0,0,0-.711,0L4.645,13.283a.5.5,0,0,0,0,.711l3.012,3.012a.5.5,0,0,0,.711-.711L5.711,13.639l2.658-2.657a.5.5,0,0,0,0-.711Z",
    transform: "translate(-4.497 -7.614)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4592",
    "data-name": "Path 4592",
    d: "M13.156,10.525a.5.5,0,0,0-.5-.5H6.127a.5.5,0,1,0,0,1h6.527A.5.5,0,0,0,13.156,10.525Zm2.51,6.025a.5.5,0,0,1-.5-.5V5a.5.5,0,1,1,1,0V16.048A.5.5,0,0,1,15.667,16.55Z",
    transform: "translate(-5.122 -4.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.2e3f7d94.svg";
export { ForwardRef as ReactComponent };